import { BaseCanvas } from "@visactor/vrender-core";

import { TaroContext2d } from "./context";

export class TaroCanvas extends BaseCanvas {
    constructor(params) {
        super(params);
    }
    init() {
        this._context = new TaroContext2d(this, this._dpr);
    }
    release(...params) {}
}

TaroCanvas.env = "taro";
//# sourceMappingURL=canvas.js.map
